export const manifest = {
  screens: {
    scr_vo8hxd: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_c2rtl0: { name: "Departments", route: "/categories", position: {"x":1560,"y":220} },
    scr_qqudz6: { name: "Brands", route: "/brands", position: {"x":2960,"y":220} },
    scr_hai43o: { name: "Wholesale & Distribution", route: "/wholesale", position: {"x":160,"y":4180} },
    scr_8v0dz2: { name: "Gallery", route: "/gallery", position: {"x":4360,"y":220} },
    scr_xsrlgi: { name: "News & Promotions", route: "/news", position: {"x":160,"y":2200} },
    scr_3m7gaq: { name: "About Us", route: "/about", position: {"x":1560,"y":2200} },
    scr_mt0qen: { name: "Contact Us", route: "/contact", position: {"x":2960,"y":2200} },
  },
  sections: {
    sec_aa9sh3: { name: "Main Shopping", x: 0, y: 0, width: 5720, height: 1180 },
    sec_159le2: { name: "Information & Content", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_yqkn5l: { name: "Wholesale Channel", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_aa9sh3", children: [
      { kind: "screen", id: "scr_vo8hxd" },
      { kind: "screen", id: "scr_c2rtl0" },
      { kind: "screen", id: "scr_qqudz6" },
      { kind: "screen", id: "scr_8v0dz2" },
    ] },
    { kind: "section", id: "sec_159le2", children: [
      { kind: "screen", id: "scr_xsrlgi" },
      { kind: "screen", id: "scr_3m7gaq" },
      { kind: "screen", id: "scr_mt0qen" },
    ] },
    { kind: "section", id: "sec_yqkn5l", children: [
      { kind: "screen", id: "scr_hai43o" },
    ] },
  ],
}
